export function isRunningAsPWA() {
  if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
    return true
  }

  return false
}
